var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConectedGoogleCloudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0274 10.3501L23.5144 7.86306L23.6801 6.81587C19.1481 2.69492 11.9439 3.16219 7.85851 7.79086C6.7237 9.07645 5.8818 10.6792 5.43286 12.3343L6.32359 12.2088L11.2975 11.3885L11.6815 10.9958C13.894 8.56592 17.635 8.23902 20.1896 10.3065L21.0274 10.3501Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0572 12.2611C26.4856 10.156 25.312 8.26358 23.6802 6.81595L20.1897 10.3065C21.6636 11.5108 22.5032 13.3251 22.4672 15.2281V15.8477C24.1829 15.8477 25.5738 17.2385 25.5738 18.9541C25.5738 20.6699 24.1829 22.0259 22.4672 22.0259H16.2454L15.6345 22.6891V26.4152L16.2454 26.9998H22.4672C26.9298 27.0345 30.5757 23.48 30.6104 19.0174C30.6314 16.3125 29.2978 13.7766 27.0572 12.2611Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0322 26.9998H16.2454V22.0258H10.0322C9.58956 22.0257 9.16085 21.9306 8.75829 21.7466L7.87683 22.0171L5.37239 24.5041L5.15424 25.3506C6.55873 26.411 8.27235 27.0074 10.0322 26.9998Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0323 10.8649C5.56955 10.8915 1.97355 14.5309 2.00015 18.9935C2.01501 21.4855 3.17889 23.8314 5.15425 25.3505L8.75831 21.7466C7.19466 21.0402 6.49985 19.2 7.20629 17.6365C7.91261 16.073 9.75286 15.3781 11.3163 16.0845C12.0053 16.3957 12.557 16.9476 12.8683 17.6365L16.4724 14.0325C14.9389 12.0279 12.5562 10.8559 10.0323 10.8649Z",
    fill: "#FBBC05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConectedGoogleCloudIcon);
export default __webpack_public_path__ + "static/media/conected-google-cloud-icon.0d29a36bc0e90b340fbd57304273ac12.svg";
export { ForwardRef as ReactComponent };